export default __webpack_public_path__ + "static/media/dispatchme-logo.f4e7ca00.webp";